import { Component }     from '@angular/core';

@Component({
    templateUrl: './toolbar.html'
})
export class ToolbarComponent {
    constructor() { }
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/toolbar/toolbar-component.ts